$(document).on("change", "#dashboard-filter-type", function(){
  __dashboard_refresh()
})

$(document).on("click", ".dashboard-machine-card", function(){
  const code = $(this).find(".machine-number").text()
  const record_id = $(this).attr("record_id")

  showModal(`Mesin ${code}`)

  __dashboard_show(record_id)
})

window.__dashboard_show = function(id){
  $.ajax({
    url: "/dashboard/index/" + id,
    dataType: 'script',
    success: function(res){
      $('.modal-body').html(res)
    }
  })
}

window.__dashboard_refresh = function(){
  const type = $("#dashboard-filter-type")

  $.ajax({
    url: "/dashboard/index/filter",
    data: {
      type: type.val()
    },
    beforeSend: function(){
      $('.card-body').html(setSpinner())
    },
    success: function(res){
      $('.card-body').html(res)
    }
  })
}

import "./idles"
import "./maintenances"
